import { Chip } from "@mui/material";
import React from "react";
import { RightFilledArrow } from "../../assets/icons/PerformanceDashboard/RightFilledArrow";

type StatusChipProps = {
  status: string | number;
  handleStatusClick?: () => void;
};
export const StatusChip = ({ status, handleStatusClick }: StatusChipProps) => {
  if (status === "pending" || status === "open") {
    return <Chip label="Pending" />;
  }
  else if (status === "held") {
    return <Chip label="To be executed" />;
  }
  else if (status === "filled") {
    return (
      <Chip
        label="Filled"
        color="success"
        deleteIcon={<RightFilledArrow />}
        onClick={handleStatusClick}
        onDelete={() => {}}
      />
    );
  }
  else {
    return <Chip label={status} />;
  }
};
